import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { SexesApi, IListItem } from '../../../apis/SexesApi/SexesApi';

export function useGetSexes() {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.sexes],
        queryFn: async (): Promise<IListItem[]> => {
            return await SexesApi.getAll();
        },
    });
} 